import { render, staticRenderFns } from "./TextColorProperties.vue?vue&type=template&id=f21257f6&scoped=true"
import script from "./TextColorProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextColorProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextColorProperties.vue?vue&type=style&index=0&id=f21257f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21257f6",
  null
  
)

export default component.exports